import React from 'react';
import { Card, CardProperties } from '@nimbus-ds/components';
import { useIsMobile } from 'commons/hooks';

interface DesktopCardProps {
  children: React.ReactNode;
  padding?: CardProperties['padding'];
}

export default function DesktopCard({
  children,
  padding = 'base',
}: DesktopCardProps): JSX.Element {
  const isMobile = useIsMobile();
  return isMobile ? (
    <>{children}</>
  ) : (
    <Card>
      <Card.Body padding={padding}>{children}</Card.Body>
    </Card>
  );
}
